<template>
  <div class="project-category">
    <h1>Création Visuelle et Sonore</h1>
    <section class="projects-section" 
    v-for="project in projects" 
    :key="project.id">
          <!-- Featured Project Row dynamically generated -->
      <div class="project-layout">
        <iframe class="resp-iframe" :src="project.src" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>  
      </div>
    </section>
    
  </div>
</template>

<script>

export default {
  data () {
    return {
      projects: [
        { 
          src: "https://player.vimeo.com/video/412000765?rel=0&title=0&byline=0&portrait=0"
        },
        { 
          src: "https://player.vimeo.com/video/412000854?rel=0&title=0&byline=0&portrait=0"
        },
      ]
    }
  },
}
</script>

<style lang="css">

  .resp-iframe
  {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    border: 0;
    padding: 50px;
  }
</style>